import Companylogo from "../CSDLogo.svg";
import Sitelogo from "../Sitelogo.svg";

const GlobalData = {
  company: {
    companyName: "CRC",
    companyPhone: "+919963633653",
    companyEmail: "mail@crcbharat.com",
    companyAddress: "Visakhapatnam, Andhra Pradesh 530017",
    companyWhatsapp: "https://api.whatsapp.com/send?phone=919963633653",

    /*Social media */
    companyfacebook: "https://www.facebook.com/VikasPandeyCRC/",
    companyinstagram: "https://www.instagram.com/crcbharatofficial/",
    companygit: "https://github.com/",
    companytwitter: "https://twitter.com/",
  },

  /*Developed and Designed by */
  cyberspacedigital: {
    companyName: "Cyber Space Digital",
    companyPhone: "+918143407758",
    companyEmail: "mail@cyberspacedigital.in",
    companyAddress: "Visakhapatnam, Andhra Pradesh 530017",
    companyWhatsapp: "https://api.whatsapp.com/send?phone=918143407758",

    companyfacebook: "https://www.facebook.com/cyber.space.digital/",
    companyinstagram: "https://www.instagram.com/cyber.space.digital/",
    companygit: "https://github.com/akhilthej/",
    companytwitter: "https://twitter.com/CyberSD1995/",
  },
};

export { GlobalData, Companylogo, Sitelogo };
